import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import PageLoading from "../../components/PageLoading";
import { GetCategoriesWithListTypes } from "../../api-requests/Get";

interface ListType {
  id: string;
  name: string;
  slug: string;
  description: string;
  isActive: boolean;
}

interface Category {
  id: string;
  name: string;
  description: string;
  ListTypes?: ListType[];
}

const Categories = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoriesData = await GetCategoriesWithListTypes();
        console.log("Categories with list types:", categoriesData);
        setCategories(categoriesData || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  const handleCreateList = (categoryId: string, listTypeId?: string) => {
    if (listTypeId) {
      navigate(`/lists/create/${categoryId}?listTypeId=${listTypeId}`);
    } else {
      navigate(`/lists/create/${categoryId}`);
    }
  };

  if (loading) {
    return <PageLoading />;
  }

  return (
    <>
      <Header />
      <div className="min-h-screen py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-white mb-4">
              Create Your Top 10 List
            </h1>
            <p className="text-xl text-gray-300">
              Choose a list type and rank your favorites
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {categories.map((category) => (
              <div
                key={category.id}
                className="card-wrap overflow-hidden shadow-lg"
              >
                <div className="">
                  <div className="">
                    <h2 className="text-3xl font-bold  mb-1">
                      {category.name}
                    </h2>
                    <p className=" text-lg">{category.description}</p>
                  </div>
                </div>
                <div className="separator-fade" />
                <div className="flex flex-col gap-2">
                  {category.ListTypes && category.ListTypes.length > 0 ? (
                    <>
                      <h3 className="text-xl font-semibold text-white mb-4">
                        Available List Types:
                      </h3>
                      <div className="flex flex-col gap-4">
                        {category.ListTypes.map((listType) => (
                          <div
                            key={listType.id}
                            className="card-container hover:bg-gray-600 transition-colors duration-200"
                          >
                            <h4 className="text-lg font-semibold text-white mb-2">
                              {listType.name}
                            </h4>
                            {listType.description && (
                              <p className="text-gray-300 text-sm mb-4">
                                {listType.description}
                              </p>
                            )}
                            <button
                              onClick={() =>
                                handleCreateList(category.id, listType.id)
                              }
                              className="w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-2 px-4 rounded-lg transition-colors duration-200"
                            >
                              Create List
                            </button>
                          </div>
                        ))}
                      </div>
                    </>
                  ) : (
                    <div className="text-center py-8">
                      <p className="text-gray-400 text-lg mb-4">
                        No specific list types available yet for this category.
                      </p>
                      <button
                        onClick={() => handleCreateList(category.id)}
                        className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-3 px-6 rounded-lg transition-colors duration-200"
                      >
                        Create General Top 10 List
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {categories.length === 0 && (
            <div className="text-center py-12">
              <div className="text-gray-400 text-lg">
                No categories available at the moment.
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Categories;
